import {createReducer} from '@reduxjs/toolkit'
import {AnyAction} from 'redux'
import {
  DELETE_RSVP_OLD,
  GET_MEMBER_RSVP_OLD,
  SEND_RSVP_OLD,
  SKIP_GET_MEMBER_EVENT_RSVP,
  UPDATE_RSVP_STATUS_OLD,
  deleteRsvp,
  getMemberRsvp,
  sendRsvp,
  updateRsvpStatus,
} from '../actions/rsvp'
import {MemberRsvp} from '../types/state'

const getDefaultState = (): MemberRsvp => ({
  rsvp: null,
  loaded: false,
})

export const memberRsvp = createReducer(getDefaultState(), builder => {
  builder
    .addCase(GET_MEMBER_RSVP_OLD.SUCCESS, (state, action: AnyAction) => {
      state.rsvp = action.payload
      state.loaded = true
    })
    .addCase(getMemberRsvp.fulfilled, (state, action) => {
      if (action.payload) {
        state.rsvp = action.payload
      }
      state.loaded = true
    })
    .addCase(SEND_RSVP_OLD.SUCCESS, (state, action: AnyAction) => {
      state.rsvp = action.payload.rsvp
      state.loaded = true
    })
    .addCase(sendRsvp.fulfilled, (state, action) => {
      state.rsvp = action.payload.rsvp
      state.loaded = true
    })
    .addCase(DELETE_RSVP_OLD.REQUEST, state => {
      state.rsvp = null
      state.loaded = true
    })
    .addCase(deleteRsvp.pending, state => {
      state.rsvp = null
      state.loaded = true
    })
    .addCase(UPDATE_RSVP_STATUS_OLD.SUCCESS, (state, action: AnyAction) => {
      const [, , status] = action.args
      state.rsvp = {...state.rsvp, status}
    })
    .addCase(updateRsvpStatus.fulfilled, (state, action) => {
      const {status} = action.meta.arg
      state.rsvp = {...state.rsvp, status}
    })
    .addCase(GET_MEMBER_RSVP_OLD.REQUEST, state => {
      state.loaded = false
    })
    .addCase(getMemberRsvp.pending, state => {
      state.loaded = false
    })
    .addCase(GET_MEMBER_RSVP_OLD.FAILURE, state => {
      state.loaded = true
    })
    .addCase(getMemberRsvp.rejected, state => {
      state.loaded = true
    })
    .addCase(SKIP_GET_MEMBER_EVENT_RSVP, state => {
      state.loaded = true
    })
})
